import styleDVFRoadmap from './style-dvf-roadmap.json';
import styleRoadmap from './style-roadmap.json';

/**
 * Patch a mapbox style file to add runtime configuration values
 *
 * Note: Legacy meilleursagents tile source has been removed.
 * Price tiles now come from AVIV APIs via aviv-layers.js.
 *
 * @param {Object} mapStyle
 * @returns {Object} The patched map style
 */
export function patchMapStyle(mapStyle) {
    // No patching needed - legacy tile source has been removed
    // AVIV tile sources are added dynamically in map.es6.js
    return mapStyle;
}

/**
 * Prices page map style
 * @type {Object}
 */
export const pricesMapStyle = styleRoadmap;

/**
 * DVF map style
 * @type {Object}
 */
export const DVFMapStyle = styleDVFRoadmap;
